import { useAuth } from '@cks-internal/react-base';
import { FrontierUser } from '../../globalModels/frontierUser';

export const useFrontierAuth = () => {
  return useAuth<FrontierUser>();
};
